
import ProductIcon from '../../common/assets/svgIcons/ProductIcon';
import ServicesIcon from '../../common/assets/svgIcons/ServicesIcon';
import ProductServiceCard from './ProductServiceCard';
import { selectProductAndServices } from '../../../Selector/CompaniesSelector';
import { useSelector } from 'react-redux';

const ProductAndServices = function ProductAndServices() {
  const productsAndServices = useSelector(selectProductAndServices);

  return (
    <div>
      {!!productsAndServices?.products?.length &&
        <ProductServiceCard title="Products" icon={<ProductIcon />} items={productsAndServices?.products || []} />
      }
      {!!productsAndServices?.services?.length &&
        <ProductServiceCard title="Services" icon={<ServicesIcon />} items={productsAndServices?.services || []} />
      }
    </div>
  );
};

export default ProductAndServices;
